module.exports = __webpack_public_path__ + "static/How-to-prototype-an-app-for-market-16567acc63fc23573ee80df5accbe644.png";